<template>
  <div>

    <EmptyModal :onModalClose="closeModal" :modalData="modalData" v-if="modalData">
      <slot>
        <img class="w-100" :src="modalData.source" alt="">
      </slot>
    </EmptyModal>

    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div v-if="!loading" class="flex flex_gap_10 flex-wrap">
      <div v-for="(r,i) in records" class="card">
        <div class="card-body">
          <img @click="openImage(r.url)" alt="img" class="pointer" :src="r.url"/>
          <p>накладная: <strong>{{ r.record.object_id }}</strong></p>
          <p>загружена: {{ r.record?.details?.uploaded_by?.user_name }} ({{ printDate(r.record.created_at) }})</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import EmptyModal from "@/components/modals/EmptyModal.vue";

export default {
  components: {EmptyModal},
  props: ['invoices'],
  data() {
    return {
      loading: false,
      records: null,
      modalData: null
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    closeModal() {
      this.modalData = null;
    },
    openImage(img) {
      this.modalData = {source: img, disableFooter: false}
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.post('/new/files/invoices/list', {
        invoices: this.invoices
      });
      if (data.success) {
        this.records = data.records;
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.card {
  max-width: 350px;
}

.card img {
  width: 100%;
}

.card p {
  margin-bottom: 0;
}
</style>
